import classNames from "classnames";
import { get, isEmpty } from "lodash";
import { useMemo, useState } from "react";
import { MdKeyboardBackspace } from "react-icons/md";
import { useTranslation } from "react-i18next";
import { CURRENCY_SYMBOL } from "utils/constants";
import { costToFrench } from "utils/helpers/values";
import { NAME_SPACES } from "shared/locales/constants";
import Button from "../Components/Button";
import Header from "../Components/Header";
import Layout from "../Components/Layout";
import DetailsModal from "./DetailsModal";
import UpsellsCard from "./UpsellsCard";

function View({
  onNext,
  onBack,
  upsells,
  selectedModules,
  handleModule,
  projectId,
  insurancePlanId,
}) {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.PROJECT);
  const [openDetails, setOpenDetails] = useState(null);

  const DETAIL = t("DETAIL", { returnObjects: true });

  // Calculate total additional cost from selected modules
  const totalAdditionalCost = useMemo(() => {
    const selected = get(selectedModules, insurancePlanId, []);
    return selected.reduce((acc, module) => acc + (module.cost || 0), 0);
  }, [selectedModules, insurancePlanId]);

  const selectedCount = get(selectedModules, insurancePlanId, []).length;
  const hasDiscount = selectedCount >= 2;

  return (
    <Layout>
      <Header
        title="Renforcez votre formule santé grâce à <b>nos options complémentaires</b>"
        highlight="nos options complémentaires"
        subtitle="Vos garanties optionnelles"
        onBack={onBack}
      />
      <div className="miltis-upsells">
        <div className="miltis-upsells__list">
          {upsells.map((module) => (
            <UpsellsCard
              key={module?.id}
              notSelected={
                !get(selectedModules, insurancePlanId)?.find(
                  ({ insurancePlan }) =>
                    insurancePlan.id === get(module, "insurancePlan.id"),
                )
              }
              name={get(module, "insurancePlan.name") || ""}
              alias={get(module, "insurancePlan.alias") || ""}
              supportingInformation={
                get(module, "insurancePlan.supportingInformation") || []
              }
              cost={get(module, "cost")}
              currency={get(module, "currency")}
              onAdd={() => handleModule({ module })}
              onDetailsClick={() =>
                setOpenDetails(get(module, "insurancePlan.id"))
              }
            />
          ))}
        </div>

        {/* Action buttons area */}
        <div className="miltis-upsells__actions">
          <div className="miltis-upsells__actions-row">
            <button
              type="button"
              className="miltis-upsells__back-btn"
              onClick={onBack}
            >
              <MdKeyboardBackspace size={24} />
              <span>Retour</span>
            </button>

            <div className="miltis-upsells__summary">
              <div className="miltis-upsells__summary-price">
                <span className="miltis-upsells__summary-amount">
                  +{costToFrench(totalAdditionalCost)}
                </span>
                <span className="miltis-upsells__summary-currency">€</span>
                <span className="miltis-upsells__summary-period">/mois</span>
              </div>
              {hasDiscount && (
                <div className="miltis-upsells__discount-badge">
                  Offre Duo -15%
                </div>
              )}
              <Button type="primary" onClick={onNext}>
                Continuer
              </Button>
            </div>
          </div>

          <button
            type="button"
            onClick={() => onNext({ ignore: true })}
            className={classNames("miltis-upsells__skip-link", {
              "miltis-upsells__skip-link--hidden": !isEmpty(
                get(selectedModules, insurancePlanId),
              ),
            })}
          >
            Je ne souhaite pas renforcer mon offre santé
          </button>
        </div>
      </div>

      {openDetails && (
        <DetailsModal
          centered
          open={openDetails}
          onClose={() => setOpenDetails(null)}
          filter={{
            where: {
              insurancePlan: { id: openDetails },
              project: { id: projectId },
            },
          }}
          translation={DETAIL.TEMPLATES.COMPARISON}
        />
      )}
    </Layout>
  );
}

export default View;
